import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function ThreeDaysIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3600">
      <div className="relative w-full h-full bg-gradient-to-b from-orange-400 to-red-500 overflow-hidden" data-id="element-3601">
        {/* Background: Warm glow */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3602">
          <circle cx="100" cy="120" r="80" fill="#FDE047" fillOpacity="0.3" filter="blur(10px)" data-id="element-3603" />
          <circle cx="100" cy="120" r="50" fill="#FEF08A" fillOpacity="0.4" filter="blur(5px)" data-id="element-3604" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[10%]" data-id="element-3605">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3606">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'happy' : 'sleeping'} variant={variant} accessory="smallFlame" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3607" />
          </div>
        </div>

        {/* Foreground: Juggling Flames */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3608">
            {/* Flame 1 (Left) */}
            <g transform="translate(40, 80) scale(0.8)" data-id="element-3609">
              <path d="M15 0 C15 0 0 15 0 25 C0 35 8 40 15 40 C22 40 30 35 30 25 C30 15 15 0 15 0 Z" fill="#F97316" data-id="element-3610" />
              <path d="M15 10 C15 10 5 20 5 28 C5 34 10 37 15 37 C20 37 25 34 25 28 C25 20 15 10 15 10 Z" fill="#FDE047" data-id="element-3611" />
            </g>

            {/* Flame 2 (Top) */}
            <g transform="translate(85, 30) scale(0.9)" data-id="element-3612">
              <path d="M15 0 C15 0 0 15 0 25 C0 35 8 40 15 40 C22 40 30 35 30 25 C30 15 15 0 15 0 Z" fill="#F97316" data-id="element-3613" />
              <path d="M15 10 C15 10 5 20 5 28 C5 34 10 37 15 37 C20 37 25 34 25 28 C25 20 15 10 15 10 Z" fill="#FDE047" data-id="element-3614" />
            </g>

            {/* Flame 3 (Right) */}
            <g transform="translate(140, 70) scale(0.7)" data-id="element-3615">
              <path d="M15 0 C15 0 0 15 0 25 C0 35 8 40 15 40 C22 40 30 35 30 25 C30 15 15 0 15 0 Z" fill="#F97316" data-id="element-3616" />
              <path d="M15 10 C15 10 5 20 5 28 C5 34 10 37 15 37 C20 37 25 34 25 28 C25 20 15 10 15 10 Z" fill="#FDE047" data-id="element-3617" />
            </g>

            {/* Motion trails */}
            <path d="M55 110 Q80 50 100 60 T150 100" fill="none" stroke="#FDE047" strokeWidth="2" strokeDasharray="4 4" strokeOpacity="0.6" data-id="element-3618" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}